const eligibleCategoryFor2RowSize = {
  JEANS: [118, 11221],
  DRESS_SHIRT: [20635],
  PANTS: [89],
  SHOE: [65, 63266, 13247, 55822, 55642, 55637, 59851, 70405, 79687, 55640],
  BLAZER: [16499],
};

module.exports = {
  eligibleCategoryFor2RowSize,
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/productModelHelper/Constant.js